document.addEventListener("DOMContentLoaded", () => {
  const tagClassMap = {
    H1: ["h1"],
    H2: ["h2"],
    H3: ["h3"],
    H4: ["h4"],
    H5: ["body-l", "reduce-width"],
    H6: ["body-l", "reduce-width"],
    P: ["body-m", "reduce-width"],
    OL: ["body-m", "reduce-width"],
    UL: ["body-m", "reduce-width"],
  };

  const elements = document.querySelectorAll(
    ".welljoy-blog-article.custom-article h1, " +
      ".welljoy-blog-article.custom-article h2, " +
      ".welljoy-blog-article.custom-article h3, " +
      ".welljoy-blog-article.custom-article h4, " +
      ".welljoy-blog-article.custom-article h5, " +
      ".welljoy-blog-article.custom-article h6, " +
      ".welljoy-blog-article.custom-article p, " +
      ".welljoy-blog-article.custom-article ol, " +
      ".welljoy-blog-article.custom-article ul"
  );

  for (const el of elements) {
    const classes = tagClassMap[el.tagName];
    if (classes) el.classList.add(...classes);

    if (el.tagName === "P") {
      const hasImage = !!el.querySelector("img");
      const hasVideo = !!el.querySelector("iframe");

      if (hasImage || hasVideo) {
        el.classList.remove("reduce-width");
      }

      const isEmpty = !el.textContent.trim();
      if (isEmpty && !hasImage && !hasVideo) {
        el.remove();
      }
    }
  }
});
